<template>
  <div
    class="alert-flex alert-position"
    :class="alertPosition(position)"
  >
    <div
      v-for="(alert, index) in alerts"
      :key="index"
      :class="[alertType(alert.type), {
        'alert-has-close': alert.hasClose,
        'alert-fade': alert.hasAnimation,
        'alert-fade-in': (alert.hasAnimation && !alert.isAnimationDone)
      }]"
    >
      <div
        v-if="alert.hasClose"
        class="i-alert-close"
      >
        <a
          role="button"
          @click="preDeleteAlert(alert)"
        >
          <icon class="icon-close-info-white" />
        </a>
      </div>
      <h2 v-if="alert.title">
        {{ $t(alert.title) }}
      </h2>
      <p
        v-if="alert.text"
        class="i-alert-text"
      >
        {{ $t(alert.text) }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { includes } from '../api/utils'
import Icon from './Icon/index.vue'

export default {
  name: 'IAlert',
  components: {
    Icon
  },

  props: {
    position: {
      type: String,
      default: 'top-center'
    }
  },

  data () {
    return {
      alertTypeClass: ['success', 'warning', 'danger']
    }
  },

  computed: {
    ...mapGetters([
      'alerts'
    ])
  },

  methods: {
    ...mapActions([
      'deleteAlert',
      'preDeleteAlert'
    ]),

    alertType (className) {
      if (includes(this.alertTypeClass, className)) {
        return `i-alert alert alert-${className}`
      } else {
        return 'i-alert alert'
      }
    },

    alertPosition (position = '') {
      const positionArr = position.split(' ')
      let className = ''
      if (positionArr.length) {
        positionArr.forEach((position) => {
          switch (position) {
            case 'top-left':
              className = 'alert-top-left'
              break
            case 'top-right':
              className = 'alert-top-right'
              break
            case 'top-center':
              className = 'alert-top-center'
              break
            case 'center':
            default:
              className = 'alert-center'
              break
          }
        })
      }
      return className
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/common/extends'
@import '~css/addon/main'
$border-percent = 80%
$background-percent = 85%

.alert-position {
  @extend .position-fixed
  z-index: 1051
  background-color: transparent

  &, &.alert-top-right {
    top: 79px
    right: 27px
  }

  &.alert-top-left {
    top: 75px
    left: 15px
  }

  &.alert-top-center {
    top: 75px
    right: auto
    left: 50%
    transform: translateX(-50%)
  }

  &.alert-center {
    top: 50%
    left: 50%
    right: auto
    transform: translate(-50%, -50%)
  }
}

.alert-flex {
  display: flex
  flex-direction: column
  justify-content: flex-end
}

.i-alert {
  position: relative
  display: inline-block
  z-index: 6
  width: auto
  max-height: 160px
  overflow: hidden
  box-shadow: 1px 1px 2px $gray
  padding: 15px 48px

  &.alert {
    margin: 0
  }

  &.alert-fade {
    @extend .visibility-hidden
    transition: opacity .3s linear, visibility 0s linear .3s

    &.alert-fade-in {
      @extend .visibility-visible
      transition: opacity .3s linear, visibility .3s linear
      animation: fade-in-animation .3s linear

      @keyframes fade-in-animation {
        from {
          opacity: 0
        }
        to {
          opacity: 1
        }
      }
    }
  }

  &.alert-has-close {
    padding-right: 40px
  }

  + .i-alert {
    margin-top: 10px
  }

  .i-alert-close {
    position: absolute
    top: 6px
    right: 6px
    cursor: pointer
  }

  h2, h3 {
    margin: 0
    font-size: 20px
    text-shadow: none
    font-weight: normal

    + .i-alert-text {
      margin: 10px 0 0
    }
  }

  .i-alert-text {
    position: relative
    max-height: 85px
    margin: 0
    overflow: hidden
  }

  &.alert-success,
  &.alert-danger,
  &.alert-warning {
    border-width: 0
  }

  &.alert-success {
    color: $white
    background-color: $pink-color
  }

  &.alert-danger {
    color: $white
    background-color: $pink-color
  }

  &.alert-warning {
    color: $white
    background-color: $pink-color
  }

  &.alert-centered {
    @extend .position-fixed
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
  }
}

.icon-close-info-white {
  width: 14px
  height: 14px
}
</style>
